import { Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
const styles = {
	main: {
		padding: 50,
		width: '100%',
		textAlign: 'center'
	},
	text: {
		lineHeight: 1,
		padding: '1rem 1.5rem 0px',
		marginBottom: 50
	}
};
const NotifyDisclaimer = () => {
	const useStyles = makeStyles(styles);
	const classes = useStyles();
	return (
		<div className={classes.main}>
			<Typography variant='h6' color='textSecondary' className={classes.text}>
				Create and share your anonymous flight activity with fellow pilots to increase situational
				awareness and the safety of the national airspace.
			</Typography>
			<Typography variant='h6' color='textSecondary' className={classes.text}>
				<strong>Note:</strong> This is not an airspace authorization or a replacement for a LAANC or
				FAA Drone Zone authorization.
			</Typography>
		</div>
	);
};

export default NotifyDisclaimer;
